export enum UserType {
  individual = 'individual',
  business = 'business',
  tax_adviser = 'tax_adviser',
}
